import React from 'react';
import { useSelector } from 'react-redux';
import { getListMembers } from 'selectors/lists';
import { views } from '../constants';

import Table from './Table';

const Members = ({ loading, view = views.researchers }) => {
  const listMembers = useSelector(getListMembers);
  const loadingStatus = loading;
  return (
    <Table
      members={listMembers?.members}
      totalMembers={listMembers?.total}
      loading={loadingStatus}
      view={view}
    />
  );
};

export default Members;
